<template>
  <div class="menu-asside-content">
    <div v-click-outside="onClickOutside" class="menu-asside">
      <template v-if="!user.username">
        <div @click="signIn">
          <font-awesome-icon class="menu-asside--icon" icon="user" />
          <span> Sign In</span>
        </div>
      </template>
      <div v-if="user.username">
        <font-awesome-icon class="menu-asside--icon" icon="user" />
        <span v-if="user.name">
          <strong> {{ user.name | truncate_20 }} </strong>
        </span>
        <span v-else>
          <strong> {{ user.username | truncate_20 }} </strong>
        </span>
      </div>
      <div @click="language">
        <font-awesome-icon class="menu-asside--icon" icon="globe" />
        <span>
          Country: <strong v-if="user.country"> {{ user.country }} </strong>
          <strong v-else> USA </strong>
        </span>
      </div>
      <div>
        <router-link style="text-decoration: none;" to="/about">
          <font-awesome-icon class="menu-asside--icon" icon="film" />
          <span> About Us</span>
        </router-link>
      </div>
      <div>
        <router-link style="text-decoration: none;" to="/privacy">
          <font-awesome-icon class="menu-asside--icon" icon="lock" />
          <span> Privacy Policy</span>
        </router-link>
      </div>
      <div v-show="user.username" @click="signOut()">
        <font-awesome-icon class="menu-asside--icon" icon="sign-out-alt" />
        <span> Sign Out</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import vClickOutside from "v-click-outside";

export default {
  name: "AssideBarComponent",
  data: () => ({
    login: true,
    directives: {
      clickOutside: vClickOutside.directive
    }
  }),
  computed: mapState(["menuAsside", "user"]),
  methods: {
    onClickOutside(event) {
      if (
        event.target.className == "menu-asside-content" ||
        event.target.className == "menu--item" ||
        event.target.className == "menu--item" ||
        event.target.className == "topbar" ||
        event.target.className == "search--input" ||
        event.target.className == "container"
      ) {
        this.$store.commit("DISABLED_MENU");
      }
    },
    signIn() {
      this.$store.commit("toggleLoginModal");
      this.$store.commit("TOGGLE_MENU_ASSIDE");
    },
    signUp() {
      this.$store.commit("toggleRegisterModal");
    },
    language() {
      this.$store.commit("TOGGLE_MENU_LANGUAGE");
    },
    async signOut() {
      this.$store.commit("signOutUser");
      this.$store.commit("EDIT_ITEMS_WATCHED_SHOWS", 0);
      this.$store.commit("EDIT_ITEMS_WATCHLIST_SHOWS", 0);
      await this.$Parse.User.logOut();
      await this.$gAuth.signOut();
      this.$store.commit("DISABLED_MENU");
    }
  }
};
</script>

<style scoped>
.menu-asside-content {
  background-color: rgba(44, 56, 72, 0.8);
  height: 200vh;
  width: 100vw;
  position: absolute;
  left: 0;
  top: 60px;
}
.menu-asside {
  background-color: #2c3848;
  width: 250px;
  position: absolute;
  right: 0;
}

.menu-asside > div {
  background-color: #1c2531;
  margin: 10px 0;
  padding: 10px 0;
  cursor: pointer;
}

.menu-asside--icon {
  padding: 0px 10px;
}

@media (min-width: 1264px) {
}
</style>
